import {Col, Layout, Row, Grid} from 'antd'
import {Link} from "react-router-dom";
import {ROUTE_PATH} from "../../../utils/constants/routes";
import {LogoIcon} from "../../../assets";
import {MyText} from "../../common";
import {useTranslation} from "react-i18next";
import { useEmbeddedLink } from '../../../utils/context/embed';
const isMobile = window.innerWidth < 768;

export const Footer = () => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const embeddedLink = useEmbeddedLink();
  
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  return (
    <Layout.Footer style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', marginTop: screens.xs ? 0 : '40px' }}>
      <Row justify="center">
        <Col span={20}>
          <Row justify='space-around' align='middle' gutter={[16, 16]} style={screens.xs ? { gap: '16px' } : {}}>
           {isTablet ? (
                <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to={embeddedLink(ROUTE_PATH.MAIN)} style={{ display: 'flex' }}>
                    <LogoIcon style={{ width: 252, height: 48 }} />
                  </Link>
                </Col>
              ) : (
                <Col flex={1} style={screens.xs ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : { display: 'flex', alignItems: 'center' }}>
                  <Link to={embeddedLink(ROUTE_PATH.MAIN)} style={{ display: 'flex' }}>
                    <LogoIcon style={{ width: 252, height: 48 }} />
                  </Link>
                </Col>
              )}

            <Col span={screens.xs ? 24 : 8}>
              <Row gutter={[8, 8]} align='middle'>
                <Col span={24} style={{textAlign: 'center'}}>
                  <Link  to={embeddedLink(`/user-agreement`)}>
                    <MyText size={16} style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                      {t("userAgreement")}
                    </MyText>
                  </Link>
                </Col>

                <Col span={24} style={{textAlign: 'center', visibility: 'hidden', display: isTablet ? 'none' : 'block'}}>
                  <Link to={embeddedLink('/privacy-policy')}>
                    <MyText size={16} style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                      {t("privacyPolicy")}
                    </MyText>
                  </Link>
                </Col>
              </Row>
            </Col>

            <Col span={screens.xs ? 24 : 8}>
              <Row gutter={[8, 8]} align='middle'>
                <Col span={24} style={{textAlign: 'end'}}>
                  <MyText size={ 16} style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                    {t("technicalSupport")}:
                  </MyText>

                </Col>

                <Col span={24} style={{textAlign: 'end'}}>
                  <Link to={embeddedLink('')}>
                    <MyText size={ 16} style={screens.xs ? { display: 'flex', justifyContent: 'center' } : {}}>
                      info@sabidamu.kz
                    </MyText>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout.Footer>
  )
}